const ADD_TO_CART = 'ADD_TO_CART';
const ADD_TO_CART_UNAVAILABLE = 'ADD_TO_CART_UNAVAILABLE';
const OPEN_CONFIGURATOR = 'OPEN_CONFIGURATOR';
const OPEN_CONFIGURATOR_UNAVAILABLE = 'OPEN_CONFIGURATOR_UNAVAILABLE';

export { ADD_TO_CART, ADD_TO_CART_UNAVAILABLE, OPEN_CONFIGURATOR, OPEN_CONFIGURATOR_UNAVAILABLE };
//# sourceMappingURL=actions.js.map
